<script>
  import { createEventDispatcher } from "svelte";

  export let game;
  export let action = "add";
  export let position = null;
  export let draggable = false;

  const dispatch = createEventDispatcher();

  function handleAction() {
    dispatch("action", game);
  }

  function handleDragStart(event) {
    dispatch("dragstart", event);
  }
</script>

<div
  class="game-row"
  class:selected={action === "remove"}
  draggable={draggable}
  on:dragstart={handleDragStart}
>
  {#if action === "remove"}
    <span class="drag-handle" title="Arrastrar para ordenar">
      ⠿
    </span>

    <span class="position-number">
      {position}
    </span>
  {/if}

  <img
    class="game-image"
    src={game.image}
    alt={game.name}
  />

  <div class="game-info">
    <div class="game-title">
      <strong>{game.name}</strong>

      <span
        class="game-type"
        class:replica={game.type === "RÉPLICA"}
      >
        {game.type}
      </span>
    </div>

    <span class="game-provider">
      {game.provider === "Directo"
        ? "Directo"
        : `Agregador: ${game.provider}`}
    </span>
  </div>

  {#if action === "add"}
    <button
      class="action-button add-button"
      on:click={handleAction}
    >
      <i class="fa-solid fa-plus"></i>
      Agregar
    </button>
  {:else}
    <button
      class="action-button remove-button"
      title="Eliminar juego"
      on:click={handleAction}
    >
      <i class="fa-solid fa-trash"></i>
    </button>
  {/if}
</div>

<style>
  .game-row {
    min-height: 45px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 10px 4px 16px;
    border-bottom: 1px solid #dee2e6;
    background: white;
  }

  .game-row:nth-child(odd) {
    background: #f1f1f1;
  }

  .game-image {
    width: 58px;
    height: 38px;
    flex-shrink: 0;
    object-fit: cover;
  }

  .game-info {
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .game-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 7px;
    font-size: 12px;
  }

  .game-provider {
    font-size: 11px;
    color: #606770;
  }

  .game-type {
    padding: 1px 5px;
    border: 1px solid #0d6efd;
    border-radius: 4px;
    color: #0d6efd;
    font-size: 9px;
    white-space: nowrap;
  }

  .game-type.replica {
    border-color: #dc3545;
    color: #dc3545;
  }

  .action-button {
    flex-shrink: 0;
    cursor: pointer;
  }

  .add-button {
    padding: 5px 10px;
    border: 1px solid #ff0090;
    border-radius: 7px;
    color: #ff0090;
    background: white;
    font-size: 12px;
  }

  .add-button:hover {
    color: white;
    background: #ff0090;
  }

  .remove-button {
    width: 28px;
    height: 28px;
    border: none;
    border-radius: 4px;
    background: #e63746;
    color: white;
  }

  .drag-handle {
    color: #495057;
    cursor: grab;
    font-size: 22px;
    user-select: none;
  }

  .position-number {
    min-width: 28px;
    padding: 6px;
    border-radius: 6px;
    background: #dee2e6;
    text-align: center;
    font-size: 12px;
  }
</style>